import { ApisauceInstance, create } from 'apisauce'

import { Config } from '@flowwai-frontend/bps-officer-web/env-config'
import { isAPISuccess } from '@flowwai-frontend/shared/api-common'
import {
   HTTP_ACCEPT_HEADER_VALUE,
   HTTP_CACHE_CONTROL_HEADER_VALUE,
   HTTP_CONTENT_TYPE_HEADER_VALUE,
   HTTP_PRAGMA_HEADER_VALUE
} from '@flowwai-frontend/shared/auth/common'

import { endpointsForUsername } from '../endPoints'
import {
   LoginWithUsernameRequestType,
   LoginWithUsernameResponseType,
   ReSendUsernameOTPAPIRequestType,
   VerifyUsernameOTPAPIRequestType,
   VerifyUsernameOTPAPIResponseType
} from '../types'

import LoginWithUsernameService from './'

const BASE_URL = Config.BACKEND_REST_URL

const LOGIN_URL = `${BASE_URL}api/iam/`

export class LoginWithUsernameServiceAPI implements LoginWithUsernameService {
   api: ApisauceInstance
   constructor() {
      this.api = create({
         baseURL: LOGIN_URL,
         headers: {
            'Content-Type': HTTP_CONTENT_TYPE_HEADER_VALUE,
            Accept: HTTP_ACCEPT_HEADER_VALUE,
            Pragma: HTTP_PRAGMA_HEADER_VALUE,
            'Cache-Control': HTTP_CACHE_CONTROL_HEADER_VALUE
         }
      })
   }
   loginWithUsername = async (requestObject: LoginWithUsernameRequestType) => {
      const response = await this.api.post<
         LoginWithUsernameResponseType | unknown
      >(endpointsForUsername.loginWithUsername, requestObject)

      if (isAPISuccess(response.status)) return response.data

      throw response.data
   }

   resendUsernameOTP = async (
      requestObject: ReSendUsernameOTPAPIRequestType
   ) => {
      const response = await this.api.post<void>(
         endpointsForUsername.sendOTP,
         requestObject
      )

      if (isAPISuccess(response.status)) return response.data

      throw response.data
   }

   verifyUsernameOTP = async (
      requestObject: VerifyUsernameOTPAPIRequestType
   ) => {
      const response = await this.api.post<
         VerifyUsernameOTPAPIResponseType | unknown
      >(endpointsForUsername.verifyOTP, requestObject)

      if (isAPISuccess(response.status)) return response.data

      throw response.data
   }
}
